export function resolveNotificationRoute(notification) {
    if (notification.type === "conversation.message.created") {
        const conversationId = notification.parent_resource?.id;
        return conversationId
            ? { path: "/admin/conversations", query: { conversationId } }
            : null;
    }
    if (notification.resource.type === "itinerary") {
        return {
            path: "/admin/itinerary",
            query: { itineraryId: notification.resource.id },
        };
    }
    if (notification.resource.type === "booking" &&
        notification.parent_resource?.type === "itinerary") {
        return {
            path: "/admin/itinerary",
            query: { itineraryId: notification.parent_resource.id },
        };
    }
    return safeInternalAdminRoute(notification.deep_link);
}
function safeInternalAdminRoute(deepLink) {
    if (!deepLink)
        return null;
    if (!deepLink.startsWith("/admin/"))
        return null;
    if (deepLink.includes("//"))
        return null;
    return deepLink;
}
